
'use strict';
angular.module('myZonePerPerferenceConfigModule', []).controller('myZonePerPerferenceConfigCtrl', [
    '$scope', 'trsHttpService', '$sessionStorage', 'modalDialog',
    function($scope, trsHttpService, $sessionStorage, modalDialog) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.type = {
                '18': 'big',
                '14': 'small'
            };
            $scope.status = {
                isChecked: $sessionStorage.get('curUserInfo') ? $scope.type[$sessionStorage.get('curUserInfo').FONTSIZE] : 'big'
            };
            $scope.params = {
                serviceid: 'mlf_extuser',
                methodname: 'getCurrUserInfo',
            };
        }

        /**
         * [initData description] 初始化
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
            headPortrait();
        }

        /**
         * [headPortrait description] 获取头像
         * @return {[type]} [description]
         */
        function headPortrait() {
            var headParams = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), headParams, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL === '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }

        /**
         * [requestData description] 获取租户信息
         * @return {[type]} [description]
         */
        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.info = data;
            });
        }
        $scope.chooseFontSize = function(type) {
            $scope.status.isChecked = type;
        };

        $scope.saveConfig = function() {
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'changeUserFontSize',
                FONTSIZE: $scope.status.isChecked === 'small' ? '14' : '18'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                let perferecne = $sessionStorage.get('curUserInfo');
                perferecne.FONTSIZE = data.FONTSIZE;
                $sessionStorage.set('curUserInfo', perferecne);
                modalDialog.alertType('保存成功', '', 'success', false);
            });
        };
    },
]);
